import {findList} from '@/numberPortal/apis/media'
//社交媒体平台维护信息
//type     业务类型 account账号、comment评论、message私信、post发帖
const state = {
    platformMainatain: {},
};

const  mutations = {
    updatePlatformMainatain (state, platformMainatain) {
        state.platformMainatain = platformMainatain;
    },
};

const actions = {
    async getPlatformMainatain({ state, commit }, platform, type) {
        if(Object.keys(state.platformMainatain).length) return

        const {data, status} = await findList({platform, type})
        if( status === 200 && data.code==='200') {
            const {list} = data
            const platformMainatain = {}
            list.forEach(item => {
                const {type, status, text, platform} = item
                if(status===2 || text){
                    if(!platformMainatain[type]) platformMainatain[type] = {}
                    if(!platformMainatain[type][platform]) platformMainatain[type][platform] = {}
                    if(text) platformMainatain[type][platform].text = text
                    if(status===2) platformMainatain[type][platform].state = status
                }
            })
            commit('updatePlatformMainatain', platformMainatain);
        }
    }
};

const getters = {
    platformMainatain: state => state.platformMainatain,
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}

